export default "__VITE_ASSET__DMrtrM22__"